<template>
    <div>
        <div>
            <b-row align-v="center">
                <b-col cols="12" md="3">
                    <app-form-input v-model="filters.nameSearch" label="Nombre"></app-form-input>
                </b-col>
                <b-col cols="12" md="3">
                    <app-form-input v-model="filters.document" label="Documento"></app-form-input>
                </b-col>
                <b-col cols="12" md="3">
                    <app-form-input v-model="filters.email" label="E-mail"></app-form-input>
                </b-col>
                <b-col cols="12" md="3" class="text-right">
                    <b-btn variant="primary" @click="onFilter(true)" size="sm"><i class="fa fa-filter"></i></b-btn>
                    <b-btn variant="secondary" @click="onFilter(false)" size="sm"><i class="fa fa-times"></i></b-btn>
                </b-col>
            </b-row>
        </div>
  <div>
      <app-data-table
        resource="event-invitation-entries"
        with="eventInvitation"
        :hard-filters="hardFilters"
        :fields="fields"
        ref="event-invitation-entries-table"
      >
        <template #buttons>
            <b-btn variant="primary" size="sm" @click="onRefresh"><i class="fas fa-sync-alt"></i></b-btn>
        </template>
        <template #cell(entry_date)="{item}">
            {{item.entry_date | datetime}}
        </template>
      </app-data-table>
  </div>
  </div>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true,
        }
    },
    data: () => ({
        fields,
        filters: {
            nameSearch: '',
            document: '',
            email: '',
        }
    }),
    computed: {
        hardFilters() {
            return {
                ...this.filters,
                eventId: this.event.id,
                sortBy: 'created_at',
                sortDir: 'desc',
            }
        }
    },
    methods: {
        onRefresh() {
            this.$refs['event-invitation-entries-table'].refresh()
        },
        onFilter(withData) {
            if(!withData) {
                Object.keys(this.filters).map(key => this.filters[key] = '')
            }
            this.$refs['event-invitation-entries-table'].refresh()
        }
    }
}
const fields = [
    {
        key: 'event_invitation.person.name',
        label: 'Invitado'
    },
    {
        key: 'event_invitation.person.document',
        label: 'Documento'
    },
    {
        key: 'event_invitation.person.email',
        label: 'E-mail'
    },
    {
        key: 'event_invitation.person.phone',
        label: 'Teléfono'
    },
    {
        key: 'entry_date',
        label: 'Fecha de ingreso'
    },
]
</script>

<style>

</style>
